import { useEffect } from "react";
import careConfig from "@careConfig";

export interface IPageTitleProps {
  title: string;
}

export default function PageHeadTitle({ title }: IPageTitleProps) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) {
      document.title = `${title} | ${careConfig.appName}`;
    } else {
      document.title = careConfig.appName;
    }
    return () => {
      document.title = prevTitle;
    };
  }, [title]);

  return <></>;
}
